import { useEffect } from 'react';
import Button, { BtnColor } from '../../components/Button/Button';
import { useDispatch, useSelector } from 'react-redux';
import { onChainOrdersLoad, onOrdersLoad } from '../../store/Orders/actions';
import Loading from '../../components/Loading';
import { Pagination } from '../../components/Pagination';
import { useQuery } from '../../utils/useQuery';
import { useTranslation } from 'react-i18next';
import { useSetFilters } from '../../hooks/useSetFilters';
import { CustomSelect } from '../../components/Shared/CustomSelect';
import { FormField } from '../../components/FormField';
import { OrdersTable } from './OrdersTable';
import { Filter } from './OrdersFilter';
import { Breadcrumbs } from '../../components/Breadcrumbs';
import { useDebounce } from '../../hooks/useDebounce';

// enum types { liveorders, completed }

export const OrderList = () => {
    const setFilters = useSetFilters();
    const { t } = useTranslation();
    const query = useQuery();
    const dispatch = useDispatch();

    const page = parseInt(query.get('page') || '') || 1;
    const perPage = parseInt(query.get('per_page') || '') || 10;
    const nameTerm = query.get('name') || '';
    const orderId = query.get('orderId') || null;
    const type = query.get('type') || null;
    const restaurant = query.get('restaurant') || null;
    const tag = query.get('tag') || null;
    const status = query.get('status') || null;

    const nameDebounce = useDebounce(nameTerm, 500) || '';
    const orderIdDebounce = useDebounce(orderId, 500) || '';

    const { orders, restaurants, loading, tags } = useSelector(({ orders }) => orders);

    const { total } = orders;

    const numPages = Math.ceil(total / perPage || 1);

    const setCurrentPage = (page) => {
        setFilters({ page });
    };

    const onChangePerPage = ({ value }) =>
        setFilters({ per_page: value, page: 1 });


    const pages = [{ name: t('Orders'), path: '/chain/orders' }];

    useEffect(() => {
        dispatch(onChainOrdersLoad({ type, page, perPage, status, tag, name: nameDebounce, orderId: orderIdDebounce, restaurant }));
    }, [type, page, perPage, status, tag, nameDebounce, orderIdDebounce, restaurant]);

    return (
        <div className="py-12">
            <div className="flex gap-6 items-center">
                <Breadcrumbs pages={pages} />
            </div>
            <Filter restaurants={restaurants} tags={tags} />

            <div className="flex mt-5">
                <div className="w-full ">
                    <div className="flex flex-col">
                        <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                            <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                                <div className="shadow-sm rounded-lg">
                                    <Loading loading={loading}>
                                        <OrdersTable orders={orders.data} />
                                        <div className="flex justify-center items-center pt-3 pb-3">
                                            <Pagination className="ml-12" numPages={numPages} currentPage={page} setCurrentPage={setCurrentPage} />
                                            <FormField className="ml-5">
                                                <CustomSelect
                                                    isSearchable={false}
                                                    defaultValue={{ label: perPage, value: perPage }}
                                                    onChange={onChangePerPage}
                                                    menuPlacement="top"
                                                    options={[
                                                        { label: 5, value: 5 },
                                                        {
                                                            label: 10,
                                                            value: 10,
                                                        },
                                                        { label: 20, value: 20 },
                                                        {
                                                            label: 50,
                                                            value: 50,
                                                        },
                                                        { label: 100, value: 100 },
                                                    ]}
                                                />
                                            </FormField>
                                        </div>
                                    </Loading>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
